import tags from '../tags';

const {
  passives: {
    offensivePassive,
    defensivePassive,
    resourcePassive,
    mobilityPassive,
    healingPassive,
    cooldownPassive,
  },
} = tags;

export default [
  {
    name: 'Resolve',
    tags: [defensivePassive],
  },
  {
    name: 'Fleet Footed',
    tags: [mobilityPassive],
  },
  {
    name: 'Exalted Soul',
    tags: [resourcePassive],
  },
  {
    name: 'Transcendence',
    tags: [healingPassive],
  },
  {
    name: 'Chant of Resonance',
    tags: [resourcePassive],
  },
  {
    name: 'Seize the Initiative',
    tags: [offensivePassive],
  },
  {
    name: "The Guardian's Path",
    tags: [defensivePassive, resourcePassive],
  },
  {
    name: 'Sixth Sense',
    tags: [defensivePassive],
  },
  {
    name: 'Determination',
    tags: [offensivePassive],
  },
  {
    name: 'Relentless Assault',
    tags: [offensivePassive],
  },
  {
    name: 'Beacon of Ytar',
    tags: [cooldownPassive],
  },
  {
    name: 'Alacrity',
    tags: [offensivePassive],
  },
  {
    name: 'Harmony',
    tags: [defensivePassive],
  },
  {
    name: 'Combination Strike',
    tags: [offensivePassive],
  },
  {
    name: 'Near Death Experience',
    tags: [defensivePassive, resourcePassive],
  },
  {
    name: 'Unity',
    tags: [offensivePassive],
  },
  {
    name: 'Momentum',
    tags: [offensivePassive],
  },
  {
    name: 'Mythic Rhythm',
    tags: [offensivePassive],
  },
];
